// extracted by mini-css-extract-plugin
module.exports = {"categoriesSection":"Categories_categoriesSection__3FayI","categoriesListWrapper":"Categories_categoriesListWrapper__4oqDW"};